import React from 'react'
import { ReactQueryProviderWrapper } from './src/data/api-adapters/react-query-provider-wrapper'
import { initLocalCache } from './src/data/local-persistence/local-cache'
import { initWindowObject } from './src/utils/browser-api'
import { initLogger, getDebugLogger } from './src/utils/logger'
import { publish } from './src/infra/route-change-pubsub'
import { AuthGuard, AuthProvider } from './src/data/contexts/auth'
import './src/styles/global.css'

initLocalCache()
initWindowObject()
initLogger()

const debug = getDebugLogger('GatsbyBrowser')

export const onRouteUpdate = ({ location, prevLocation }) => {
  const newPath = location.pathname
  const oldPath = prevLocation && prevLocation.pathname
  debug('onRouteUpdate', { newPath, oldPath })
  publish(newPath, oldPath)
}

export function wrapRootElement({element}) {
  return (
    <AuthProvider>
      <AuthGuard>
        <ReactQueryProviderWrapper>
          {element}
        </ReactQueryProviderWrapper>
      </AuthGuard>
    </AuthProvider>
  )
}
